import { put, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../../constants/action-types';
import { SelectedSegmentReducerActions } from './types';

const SEGMENT_ACTIONS = [
  ActionTypes.SEGMENT_DESELECT,
  ActionTypes.SEGMENT_SELECT,
];

export function* watcherSaga() {
  yield takeLatest(SEGMENT_ACTIONS, worker);
}

function worker(action: SelectedSegmentReducerActions) {
  put(action);
}
